import { handleActions } from 'redux-actions';

const initialState = {
  isProcessing: false,
  failure: false,
  data: [],
};

export default handleActions(
  {
    'STORE/REQUEST': (state, action) => {
      return Object.assign({}, state, {
        isProcessing: true,
      });
    },
    'STORE/SUCCESS': (state, action) => {
      return Object.assign({}, state, {
        isProcessing: false,
        failure: false,
        data: action.payload.data,
      });
    },
    'STORE/FAILURE': (state, action) => {
      return Object.assign({}, state, {
        isProcessing: false,
        failure: true,
      });
    },
  },
  initialState
);